/**
 * @param {jQuery} $
 * @param {AppConfig} config
 * @param {AppLibrary} library
 * @constructor
 */
export let Widget = function ($, config, library) {

  /**
   * @type {string}
   */
  let template = `
{{#pointsText}}
    <div class="slp-product-widget">
        <span class="slp-product-widget-text">` + config.getPopupText().youCanEarn + `</span>
        <span class="slp-product-widget-points" data-loyalty-points-text>{{pointsText}}</span>
    </div>
{{/pointsText}}`;

  /**
   * @type {HTMLElement}
   */
  let widgetElement, pointsTextElement;

  /**
   * @type {boolean}
   */
  let pointsInfoRange = config.getInfoType() === 'range';

  /**
   * @type {number}
   */
  let purchasePointsRate = config.getPurchaseRate();  // i.e. 1 point for each X$

  /**
   * @type {{singular: string, plural: string}}
   */
  let pointNames = config.getPointNames();

  /**
   * @type {{id: int, variants: []}}
   */
  let product = config.snippet().product;

  /**
   * @type {{available: boolean, price: number}}
   */
  let currentVariant = config.snippet().current_variant;

  /**
   *
   */
  let init = () => {
    widgetElement = document.createElement('div');
    widgetElement.className = 'slp-product-widget-wrapper';
    widgetElement.style.display = 'none';
    widgetElement.innerHTML = library.mustache().render(
        config.customization().widgetTemplate || template,
        {
          pointsText: getPointsText()
        }
    );

    pointsTextElement = widgetElement.querySelector('[data-loyalty-points-text]');

    placeWidget(() => {
      if (!pointsInfoRange) {
        subscribeOnVariantsUpdate();
      }
      if (config.customization().onWidgetReady(this)) {
        this.show();
      }
    });
  };

  /**
   * @return {string}
   */
  let getPointsText = function () {
    let pointsMin, pointsMax;
    if (pointsInfoRange) {
      let priceMin, priceMax;
      priceMin = priceMax = currentVariant.price;
      for (let i = 0; i < product.variants.length; i++) {
        priceMin = Math.min(priceMin, product.variants[i].price);
        priceMax = Math.max(priceMax, product.variants[i].price);
      }
      pointsMin = priceToPoints(priceMin);
      pointsMax = priceToPoints(priceMax);
    } else {
      pointsMin = pointsMax = priceToPoints(currentVariant.price);
    }
    if (pointsMax === 0) {
      return '';
    }
    return '' +
        (pointsMin === pointsMax ? pointsMax : pointsMin + ' - ' + pointsMax) +
        ' ' +
        (pointsMax === 1 ? pointNames.singular : pointNames.plural);
  };

  /**
   *
   */
  let updatePointsText = () => {
    pointsTextElement.innerHTML = getPointsText();
  };

  /**
   * @param {number} price
   * @return {number}
   */
  let priceToPoints = (price) => {
    if (!purchasePointsRate) {
      return 0;
    }
    return Math.floor(price / (purchasePointsRate * 100));
  };

  /**
   * @param {function} callback
   */
  let placeWidget = (callback) => {
    let selector = config.getWidgetSelector();
    let target = document.querySelector(selector.selector);
    if (!target) {
      setTimeout(
          () => {
            target = document.querySelector(selector.selector);
            if (target) {
              throw new Error('Unable to find target element for widget component');
            }
            library.appendElement(target, widgetElement, selector.position);
            callback();
          },
          config.customization().widgetDelay || 1500
      );
    }
    library.appendElement(target, widgetElement, selector.position);
    callback();
  };

  /**
   *
   */
  let subscribeOnVariantsUpdate = () => {
    let timeout = config.customization().widgetVariantsUpdateDelay || 0;
    setTimeout(
        () => {
          let selects = getVariantsSelects();
          $(selects.main).add(selects.options).on('change', () => {
            setTimeout(() => this.update(selects.main.value), 50);
          });
        },
        timeout
    );
  };

  /**
   * @return {{main: HTMLElement, options: NodeList}}
   */
  let getVariantsSelects = () => {
    // Find main select
    let mainSelector = config.customization().widgetVariantsElementMainSelector || 'form[action="/cart/add"] select[name="id"]';
    let mainSelect = document.querySelector(mainSelector);
    if (!mainSelect) {
      throw new Error('Can\'t find main variants select element with selector \'' + mainSelector + '\'');
    }

    // Find options selects
    let optionsSelects;
    let customSelector = config.customization().widgetVariantsElementOptionsSelector;
    if (customSelector) {
      // Find elements by custom selector
      optionsSelects = document.querySelectorAll(customSelector);
      if (!optionsSelects.length) {
        throw new Error('Can\'t find variants select element with custom selector \'' + customSelector + '\'');
      }
    } else {
      let optionsSelector = 'select.single-option-selector';
      optionsSelects = document.querySelectorAll(optionsSelector);
      if (!optionsSelects.length) {
        let prefixes = [
          'product-select', 'productSelect', 'ProductSelect', 'product-variants',
          'product-selectors', 'variant-listbox', 'single-option', 'productSelect-product-template'
        ];
        for (let i = 0; i < prefixes.length; i++) {
          optionsSelector = ''
              + "select[id|='" + prefixes[i] + "-option'],"
              + "select[id|='" + prefixes[i] + '-' + product.id + "-option'],"
              + "select[id|='" + prefixes[i] + '-' + product.id + "product-option'],"
              + "select[id|='" + prefixes[i] + '-' + product.id + "productproduct-template-option']"
          ;
          optionsSelects = document.querySelectorAll(optionsSelector);
          if (optionsSelects.length) {
            break;
          }
        }
      }
    }
    return {
      main: mainSelect,
      options: optionsSelects  // селекты с опциями товара (напр., цвет, размер)
    };
  };

  /**
   * @param {int} variantId
   * @return {{available: boolean, price: number}|null}
   */
  let getVariantById = (variantId) => {
    for (let i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id == variantId) {
        return product.variants[i];
      }
    }
    return null;
  };

  /**
   *
   */
  this.show = () => {
    if (!pointsInfoRange && !currentVariant.available) {
      return;
    }
    widgetElement.style.display = 'block';
    config.customization().onWidgetShown(this);
  };

  /**
   *
   */
  this.hide = () => {
    widgetElement.style.display = 'none';
  };

  /**
   * @param {int} variantId
   */
  this.update = (variantId = 0) => {
    if (variantId) {
      let variant = getVariantById(variantId);
      if (!variant) {
        throw new Error('Can\'t find product variant with id ' + variantId);
      }
      currentVariant = variant;
    }
    if (currentVariant.available) {
      updatePointsText();
      this.show();
    } else {
      this.hide();
    }
  };

  /**
   * @return {{widget: HTMLElement}}
   */
  this.getDomElements = () => {
    return {widget: widgetElement};
  };

  init();
};